var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0167 2.4248C7.25835 2.4248 5.01668 4.66647 5.01668 7.4248V9.83314C5.01668 10.3415 4.80001 11.1165 4.54168 11.5498L3.58335 13.1415C2.99168 14.1248 3.40001 15.2165 4.48335 15.5831C8.07501 16.7831 11.95 16.7831 15.5417 15.5831C16.55 15.2498 16.9917 14.0581 16.4417 13.1415L15.4833 11.5498C15.2333 11.1165 15.0167 10.3415 15.0167 9.83314V7.4248C15.0167 4.6748 12.7667 2.4248 10.0167 2.4248Z",
    stroke: "#141413",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5583 2.66621C11.3 2.59121 11.0333 2.53288 10.7583 2.49954C9.95834 2.39954 9.19167 2.45788 8.47501 2.66621C8.71667 2.04954 9.31667 1.61621 10.0167 1.61621C10.7167 1.61621 11.3167 2.04954 11.5583 2.66621Z",
    stroke: "#141413",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5167 15.8838C12.5167 17.2588 11.3917 18.3838 10.0167 18.3838C9.33333 18.3838 8.7 18.1005 8.25 17.6505C7.8 17.2005 7.51666 16.5671 7.51666 15.8838",
    stroke: "#141413",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.bdb4e6ac67e8c9f54019512c06766a72.svg";
export { ForwardRef as ReactComponent };